import { useEffect, useRef, useState } from "react"
import LineChart from "../../Components/highChart/new/NewLineChartGraficoElecciones"
import { listaColoresChart } from "../../Components/shared/colores";
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { getEcenariosFuente, getEmpresasFuente, getFuenteGrafico, getGraficoDataEspontanea, getGraficoPagina } from '../../services/service';
import highchartsSeriesLabel from 'highcharts/modules/series-label'; // Importar el módulo series-label
import Highcharts from 'highcharts'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loading from "../../Components/shared/Loading/Loading";
import ts from "typescript";
import { log } from "console";

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 11 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition, fontSize: 14};
    }
};


interface DataObject {
    Orden: string;
    Empresa: string;
    Candidatos: string;
    [key: string]: string; // Allow for dynamic keys for date columns
  }
  

const GraficoELeccionesMPVTest = () => {
    const divRef = useRef(null);

    const  [categories, setCategories] = useState([])
    const [data, setdata] = useState({tituloProps:'',subtitleProps:'',selectValueProsp:[],formatDataStringData:'%',disableFilterProps:true,numDecimalProps:0,pieTextProps:'',showPieTextInGraph:true,showLineTop:true,showSeries:true})
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [stateLoading, setstateLoading] = useState(false)
    const [valuesSelected, setValuesSelected] = useState([]);
    const [categoiesValue, setCategoiesValue] = useState([]);

    const [valueData,setValuesData]=useState<any[]>()
    //@ts-ignore
    const [valueOptionsFuente, setvalueOptionsFuente] = useState<any>([]);
    const [dataMVP, setdataMVP] = useState<any>([]);
   

    highchartsSeriesLabel(Highcharts);


    const exportToPDF = () => {
        const element = document.getElementById('element-to-export');
    //@ts-ignore
        html2canvas(divRef.current).then(canvas => {
          const pdf = new jsPDF('p', 'mm', 'a4');
          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 100);
          pdf.save('Elecciones_presidenciales_2025.pdf');
        });}
    const {tituloProps,subtitleProps,selectValueProsp,formatDataStringData,disableFilterProps,
        numDecimalProps,
        pieTextProps,
        showPieTextInGraph,
        showLineTop,
        showSeries} = data
        

        const handleCapture = () => {
            if (divRef.current) {
              html2canvas(divRef.current).then(canvas => {
                // Generar imagen base64
                const imgData = canvas.toDataURL('image/png');
                // Crear un enlace para descargar la imagen
                const link = document.createElement('a');
                link.download = 'Elecciones_presidenciales_2025.png';
                link.href = imgData;
                link.click();
              });
            }
          };
        const exportExcel = (params: any) => {
            //Creo un nuevo excel
            const wb = XLSX.utils.book_new();
            console.log('====================================');
            console.log('export',apiData);
            console.log('====================================');
            //Se setean los datos al formato para el excel
            const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));
    
            //Se crea una pagina por cada cada grafico con sus respectivos datos
            XLSX.utils.book_append_sheet(wb, data, 'Grafico');
    
            //Se descarga el excel
            XLSX.writeFile(wb, "Data " + "Grafico" + ".xlsx")
        }
        const setDataGraficoForExcel = (data: any) => {
            console.log('====================================');
            console.log('DATA',data);
            console.log('====================================');
            console.log(data[0].data);
            console.log('====================================');
            console.log('====================================');
            const arrayvalue:any = [        ]

            const array = data.forEach((item: any) => {

                item.data.forEach((item2: any) => {
        
                    let obj:any = {}
                    item2.data.forEach((itemData:any)=>{
                        obj[itemData.propiedad]=itemData.valor
                    })
  
                    arrayvalue.push({candidato:item.value,empresa:item2.candidato,...obj})
                })

            })
            
           return arrayvalue
        }


        const onChangeSelectFuente = async (value: any,arrayCategory?:any[]) => {
            
            
            let arrayCategoriasParam = arrayCategory?arrayCategory:categoiesValue
            
            setvalueOptionsFuente(value)
            let fuente:any[] =[]
            let labels:any={}


            value.forEach((elementFuente:any) => {
                let arrayValue:any[] =[]
                elementFuente.data.forEach((element:any,indexelemen:any) => {
                    

                let valueGraph:any ={name: element.candidato,data:[],visible:element.candidato.includes('Cadem')}

                
               // Get entries from the fourth property onwards
                
               element.data.forEach((element:any)=>{
                    
                if(labels.hasOwnProperty(element.propiedad)){
                    if (!isNaN(Number(element.valor))){
                        labels[element.propiedad]=true
                        
                    }
                }
                else{
                    // console.log('Value elne',value);
                    if (!isNaN(Number(element.valor))){
                        // console.log('Value',value,indexelemen);
                        
                        labels[element.propiedad]=true

                    }else{
                        labels[element.propiedad]=false

                    }
                }

                
                if  (!isNaN(Number(element.valor))) {
                    valueGraph.data.push(Number(element.valor))

                }  else{
                    valueGraph.data.push('-')


                } 
            }) 
                arrayValue.push(valueGraph)
            
            });
            fuente.push(...arrayValue)
            // console.log('arrayValue',arrayValue);

            });

            
          

            const labelsFilter:any = arrayCategoriasParam.filter((element:any,index:any) => labels[element]===true)
            const categiesFilter = arrayCategoriasParam.map((element:any,index:any) =>   labels[element]===true? index:null).filter((element:any) => element!==null)
            
            const newValueFuente = fuente.map((element:any) => {
                let data = element.data.filter((_: any, index: any) => categiesFilter.includes(index))
                
                return {name:element.name,data:data,visible:element.visible}
            })
            
        
            
      
            console.log('newValueFuente',newValueFuente);
            
            setValuesData(newValueFuente)
            setCategories(labelsFilter)
            // console.log('labels',labelsFilter); 

            
            // console.log('filter',categiesFilter);

            

        }

        const cargarDats = async () =>{

            await getGraficoDataEspontanea().then((r:any) =>{
                setdataMVP(r.data.data)
                setApiData(r.data.data)
                
                const category =r.data.data[0].data[0].data.map((data:any)=> data.propiedad)
                setCategoiesValue(category)
                console.log(r.data.data);
                // console.log([r.data.data[0],r.data.data[1],r.data.data[5]]);
                // onChangeSelectFuente([r.data.data[8],r.data.data[9],r.data.data[13]],category);
                onChangeSelectFuente([r.data.data[0],r.data.data[1],r.data.data[4]],category);


                  })
    
        }
        
  

        useEffect(() => {   
            
            cargarDats()
        
      
            
            

        }, [])
        
   
   
    return (
        <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className={`d-flex justify-content-center border-top-graph`} >
            <div className="bg-body rounded chart-content mt-3">
      {stateLoading ? <Loading loading={stateLoading} /> : null}

              <div className="d-flex gap-2">
              <div className="flex1">
              <Select
                 className="react-select-container flex1"
                 isMulti
                 classNamePrefix="react-select "
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={dataMVP}
                    //@ts-ignore
                    onChange={(e)=>onChangeSelectFuente(e,null)}
                    value={valueOptionsFuente}
                />
</div>


               
              </div>

                <div ref={divRef} className='mt-3 container-graphLine'>
                    <LineChart
                        allData={valueData}
                        title={'Elección presidencial 2025. Respuesta espontánea'}
                        subtitle={''}
                        numDecimalProps={numDecimalProps}
                        pieTextProps={pieTextProps}
                        showSeries={showSeries}
                        formatDataStringData={formatDataStringData}
                        showPieTextInGraph={showPieTextInGraph}
                        labels={categories}
                        colores={arrayColores}
                        exportExcel={exportExcel}
                        exportarImagen={handleCapture}
                        activeButton={true}
                    />
                </div>
             
            </div>
              {/* <ChartV5 /> */}
            </div>
          </div>
        </div>
      </div>
    )
}

export default GraficoELeccionesMPVTest